import React from "react";
import styles from "../../style.module.scss";

/**
 * RateItem component for displaying a rate label and value
 * @param {Object} props - Component props
 * @param {string} props.label - Rate label text
 * @param {string|number} props.value - Rate value
 * @param {string} [props.className] - Additional CSS class names
 * @returns {React.ReactElement} RateItem component
 */
const RateItem = ({ label, value, className }) => {
  return (
    <div className={`${styles.rateItem} ${className || ""}`}>
      <span className={styles.rateLabel}>{label}</span>
      <span className={styles.rateValue}>{value}</span>
    </div>
  );
};

export default RateItem;
